import InfoIcon from "@mui/icons-material/InfoOutlined";
import RecipientsIcon from "@mui/icons-material/PeopleOutlineRounded";
import { Paper, Stack, Tooltip, Typography } from "@mui/material";
import { pluralize } from "@entrilia/shared/utilities/stringHelper";

interface Props {
  recipientsCount: number;
  isSelectionChanged: boolean;
}

const InvestorCommunicationRecipientsPreviewBar = ({ recipientsCount, isSelectionChanged }: Props) => (
  <Paper variant="outlined" sx={{ bgcolor: "background.grey" }}>
    <Stack direction="row" spacing={1} sx={{ alignItems: "center", px: 2, py: 1.5 }}>
      <RecipientsIcon color="action" />
      {isSelectionChanged ? (
        <Typography color="textSecondary">
          Save your changes to see who matches the funds and categories selected above
        </Typography>
      ) : (
        <>
          <Typography variant="subtitle2">
            {recipientsCount} {pluralize("recipient", recipientsCount)} today
          </Typography>
          <Tooltip arrow title="Estimate based on today's matches. The audience is dynamic and can change">
            <InfoIcon color="action" />
          </Tooltip>
          <Typography color="textSecondary">match the funds and categories selected above</Typography>
        </>
      )}
    </Stack>
  </Paper>
);

export default InvestorCommunicationRecipientsPreviewBar;
